<template>
  <div class="modal report-modal">
    <div class="overlay" @click="closeModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="overflow">
          <img class="close" @click="closeModal" src="./../images/close.svg" />
          <div class="title small">
            {{ $t("Are you sure you want to send report ?") }}
          </div>
          <div class="buttons">
            <button class="button bordered-white" @click="closeModal">
              {{ $t("Cancel") }}
            </button>
            <button class="button colored" @click="apply">
              {{ $t("Apply") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportModal",
  props: [],
  data: function () {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    apply() {
      this.$emit("apply");
    },
  },
};
</script>
